import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=f90d08ae&scoped=true"
import script from "./Notify.vue?vue&type=script&lang=js"
export * from "./Notify.vue?vue&type=script&lang=js"
import style0 from "./Notify.vue?vue&type=style&index=0&id=f90d08ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90d08ae",
  null
  
)

export default component.exports